<template>
  <model-form
    ref="modelForm"
    :model="siteLocationZone"
    modal-type="modal"
    width="500px"
  >
    <div class="q-gutter-sm">
      <q-input
        v-model="siteLocationZone.name"
        label="Name"
        :rules="[val => !!val || 'Field is required']"
        bottom-slots
      />
      <q-select
        v-model="siteLocationZone.siteIds"
        label="Sites"
        :options="sitesExcludingLibrary"
        option-value="id"
        option-label="name"
        multiple
        use-chips
        map-options
        emit-value
        bottom-slots
      />
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'SiteLocationZoneForm',
  components: {
    ModelForm
  },
  computed: {
    sitesExcludingLibrary () {
      return _(this.sites.data).filter({ isLibrary: false }).value()
    }
  },
  configuration: ['sites'],
  models: {
    siteLocationZone: {
      sites: {
        id: true,
        name: true
      }
    }
  }
}
</script>
